export default function ({ $auth, redirect }) {
  // If the user is not authenticated
  if (!$auth.$state.loggedIn) {
    return redirect('/?message=Om%20deze%20pagina%20te%20bekijken%20moet%20je%20inloggen%20met%20jouw%20account.')
  }
}
